@import "~/styles/variables";

$modal-sidebar-background: $color-grey-light;

.ModalHeader {
  @include font-size("m");
  @include font-weight("semibold");
  padding: $space-m $space-xl $space-m $space-m;
  background: $modal-sidebar-background;
  border-radius: $border-radius-xl $border-radius-xl 0 0;
}
